// components/Modal.js
import React from 'react';
import { X } from 'lucide-react';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay-comp" onClick={onClose}>
      <div className="modal-content-comp" onClick={e => e.stopPropagation()}>
        <div className="modal-header-comp">
          <h3>{title}</h3>
          <button className="close-btn" onClick={onClose}><X size={20} /></button>
        </div>
        <div className="modal-body-comp">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;